module.exports = __webpack_public_path__ + "static/media/Sedimento.63fe8ba4.svg";